import { render, staticRenderFns } from "./ReportNoteDetail.vue?vue&type=template&id=2ca64432&scoped=true"
import script from "./ReportNoteDetail.vue?vue&type=script&lang=js"
export * from "./ReportNoteDetail.vue?vue&type=script&lang=js"
import style0 from "./ReportNoteDetail.vue?vue&type=style&index=0&id=2ca64432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca64432",
  null
  
)

export default component.exports